<template>
  <section class="framework">
    <page-header v-if="!ishome"></page-header>
    <!-- <HomepageHeader v-else></HomepageHeader> -->
    <div class="page-container">
      <router-view />
    </div>
    <page-footer v-if="!ishome"></page-footer>
  </section>
</template>

<script>
import pageHeader from "./Header";
import HomepageHeader from "./HomeHeader";
import pageFooter from "./Footer";
import mobileFooter from "./MobileFooter";
import Config from "../../../config/config";
export default {
  components: {
    pageHeader,
    HomepageHeader,
    pageFooter,
    mobileFooter,
  },
  data() {
    return {
      ishome: Config.ishome,
    };
  },
  methods: {
    // 获取页面滚动高度
    // show() {
    //   console.log("22222222222");
    // }
  },
  // methods: {
  //   show() {
  //     console.log('22222222222');
  //     console.log(Config.ishome);
  //   }
  // },
  watch: {
    $route(to, from) {
      const path = this.$route.path;

      console.log(path);

      if (path == "/Home") {
        this.ishome = true;
      } else {
        this.ishome = false;
      }
    },
  },
  created() {
    const path = this.$route.path;
    if (path == "/Home") {
      this.ishome = true;
    } else {
      this.ishome = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.framework {
  height: auto;
  min-height: 100%;
  .page-container {
    min-height: calc(100vh - 344px);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Layout/index.vue